import { createAction, Action, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { debug } from '../../../utils';
import actions from './actions';

const _authReducers = {
    [actions.AUTHENTICATE]: (state, action) => {
        //const { mapComponent } = action.payload;
        return true;
    },
    [actions.DEAUTHENTICATE]: (state, action) => {
//        const { mapComponent } = action.payload;
        return false;
    }
};

const _cookieReducers = {
    [actions.SET_COOKIE]: (state, action) => {
        //const { mapComponent } = action.payload;
        return action.payload;
    },
    [actions.CLEAR_COOKIE]: (state, action) => {
//        const { mapComponent } = action.payload;
        return false;
    },
	[actions.DEAUTHENTICATE]: (state, action) => {
		//        const { mapComponent } = action.payload;
    return false;
  }
};


const initialState = false;
const authReducers = handleActions<any>(_authReducers, initialState);
const cookieReducers = handleActions<any>(_cookieReducers, initialState);

export default { auth: authReducers, cookie: cookieReducers};



// WEBPACK FOOTER //
// ./src/app/models/Auth/reducers.ts